import { PaginatedQueryParams } from 'queries/queries-utils'

export const scenariosQueryKeys = {
  getScenariosActivePaged: (
    params: { teamId: string } & PaginatedQueryParams
  ) => ['scenarios/active/paged', params] as const,
  getScenariosActiveRuns: (query: Record<string, string | number | null>) =>
    ['scenarios/active-runs', query] as const,
  getCompletedPaged: (params: { pageSize: number; teamId: string }) =>
    ['scenarios/completed/paged', params] as const
}
